// extracted by mini-css-extract-plugin
export default {"margins":"ButtonsPage-margins__d88f1b9a5fff2df5a182"};